import React from 'react';
import { isEmpty, cloneDeep, filter } from 'lodash';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import SetPlaces from './SetPlaces';
import Type from './Type';
import ACButton from '../../atoms/ACButton';

import styles from './MoreToExplorePlaces.module.scss';

export default class MoreToExplorePlaces extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: -1,
      isModifyingPlaces: false,
    };
    this.onAddPlace = this.onAddPlace.bind(this);

    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickPlace = this.onClickPlace.bind(this);
    this.onSelectType = this.onSelectType.bind(this);

    this.highlightDestination = this.highlightDestination.bind(this);
    this.onSwapComplete = this.onSwapComplete.bind(this);
  }

  onOpenModal() {
    this.setState({
      isModifyingPlaces: true,
    });
  }

  onCloseModal() {
    this.setState({
      isModifyingPlaces: false,
    });
    this.props.clearSetPlacesFunc();
  }

  highlightDestination(placeNumber) {
    this.setState({
      highlight: placeNumber,
    });
  }

  onAddPlace() {
    this.props.onSelectTypeFunc({}, []);
    this.onOpenModal();
  }

  onSaveMtePlaces = () => {
    this.props.onSaveMtePlacesFunc();
    this.onCloseModal();
  };

  onClickPlace(type) {
    // TODO: Implement Me
    this.onOpenModal();
  }

  onSelectType(type, mtePlaces) {
    this.props.onSelectTypeFunc(type, mtePlaces);
    this.onOpenModal();
  }

  onSwapComplete(from, to) {
    this.setState({ highlight: -1 });
    this.props.onSwapPlacesFunc(from, to);
  }

  renderMtePlaces(types, places) {
    if (isEmpty(types)) return <div />;
    let typeNumber = 0;

    return types.map(t => {
      ++typeNumber;
      const filteredPlaces = cloneDeep(filter(places, { type: t.value }));
      const type = cloneDeep(t);
      if (!isEmpty(filteredPlaces))
        return (
          <Type
            key={'mteType' + typeNumber}
            typeNumber={typeNumber}
            type={type}
            places={filteredPlaces}
            onSwapPlacesFunc={this.onSwapComplete}
            highlightDestinationFunc={this.highlightDestination}
            highlight={this.state.highlight}
            onSelectTypeFunc={() => this.onSelectType(type, filteredPlaces)}
          />
        );
      else return null;
    });
  }

  render() {
    const { mtePlaces, types } = cloneDeep(this.props);
    return (
      <div className={styles.root}>
        <div className={styles.title}>
          <div
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
            }}
          >
            Available Places
          </div>

          <ACButton
            text={'Add'}
            icon={<AddCircleOutlineIcon key="mtePlaceAddKey" />}
            iconLast={true}
            onClickFunc={this.onAddPlace}
          />
        </div>
        {this.renderMtePlaces(types, mtePlaces)}
        <SetPlaces
          types={types}
          places={this.props.places}
          selectedPlaces={this.props.selectedPlaces}
          selectedType={this.props.selectedType}
          selectedPlace={this.props.selectedPlace}
          isModifying={this.state.isModifyingPlaces}
          onCloseFunc={this.onCloseModal}
          onChangeTypeFunc={this.props.onChangeTypeFunc}
          onChangePlaceFunc={this.props.onChangePlaceFunc}
          onAddSelectedPlaceFunc={this.props.onAddSelectedPlaceFunc}
          onSaveMtePlacesFunc={this.onSaveMtePlaces}
          onDeletePlaceFunc={this.props.onDeletePlaceFunc}
          onDeletePlacesFunc={this.props.onDeletePlacesFunc}
          onInputChangePlaceFunc={this.props.onInputChangePlaceFunc}
        />
      </div>
    );
  }
}
